import styled from 'styled-components';

const StyledTh = styled.th`
    background-color: #f2f2f2;
`;

export default StyledTh;
